import {Avatar, styled} from "@mui/material";

const Cover = styled(Avatar)(({src})=>({
    src: src || 'url(/static/noImage.svg)'
}))

export default Cover